import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import Login from './pages/Login';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Tracking from './pages/Tracking';
import SubmitReview from './pages/SubmitReview';
import NotFound from './pages/NotFound';
import './App.css';
import Header from './components/Header';

function App() {
  useEffect(() => {
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;

        script.onload = () => resolve(script);
        script.onerror = () => reject(new Error(`Script load error for ${src}`));

        document.body.appendChild(script);
      });
    };

    const loadStylesheet = (href) => {
      return new Promise((resolve, reject) => {
        const link = document.createElement('link');
        link.href = href;
        link.rel = 'stylesheet';

        link.onload = () => resolve(link);
        link.onerror = () => reject(new Error(`Stylesheet load error for ${href}`));

        document.head.appendChild(link);
      });
    };

    // Load stylesheets in parallel
    const stylesheets = [
      'css/bootstrap.min.css',
      'css/flaticon.css',
      'css/mega-menu/mega_menu.css',
      // 'css/font-awesome.min.css',
      'css/all.min.css',
      'css/owl-carousel/owl.carousel.css',
      'css/magnific-popup/magnific-popup.css',
      'css/jquery-ui.css',
      'revolution/css/settings.css',
      'css/animate.min.css',
      'css/style.css',
      'css/style-new.css',
      'css/responsive.css',
    ];

    Promise.all(stylesheets.map(loadStylesheet))
      .catch(error => console.error('Error loading stylesheets:', error));

    // Load scripts in sequence to maintain dependencies
    const scripts = [
      'js/jquery-3.6.0.min.js',
      'js/popper.js',
      'js/bootstrap.min.js',
      'js/mega-menu/mega_menu.js',
      'js/jquery.appear.js',
      'js/counter/jquery.countTo.js',
      'js/isotope/isotope.pkgd.min.js',
      'js/owl-carousel/owl.carousel.min.js',
      'js/jquery-ui.js',
      'js/select/jquery-select.js',
      'js/magnific-popup/jquery.magnific-popup.min.js',
      'js/video/jquery.vide.js',
      'js/custom.js'
    ];

    scripts.reduce((promise, script) => {
      return promise.then(() => loadScript(script));
    }, Promise.resolve())
      .catch(error => console.error('Error loading scripts:', error));

    // Cleanup function
    return () => {
      const loadedScripts = document.querySelectorAll('script[src^="js/"]');
      const loadedStyles = document.querySelectorAll('link[href^="css/"]');

      loadedScripts.forEach(script => script.remove());
      loadedStyles.forEach(style => style.remove());
    };
  }, []);

  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    // Create a named function for the event handler
    const handleLoad = () => setLoading(false);
    
    // Add event listener
    window.addEventListener('load', handleLoad);
    
    // Also add a safety timeout to ensure loading state is cleared even if load event doesn't fire
    const safetyTimer = setTimeout(() => setLoading(false), 5000);
    
    // Proper cleanup
    return () => {
      window.removeEventListener('load', handleLoad);
      clearTimeout(safetyTimer);
    };
  }, []);

  return (
    <Router>
      {/* {loading && (
        <div id="loading">
          <div id="loading-center">
            <img src="images/loader3.gif" alt="Loading..." />
          </div>
        </div>
      )} */}
      <div className="wrapper">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms-and-conditions" element={<Terms />} />
          <Route path="/tracking" element={<Tracking />} />
          <Route path="/submit-review" element={<SubmitReview />} />
          <Route path="/submit-review/:ticketNumber" element={<SubmitReview />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
